import { OverDeliveryPolicyEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/over-delivery-policy.enum";

/**
 * i18n key mapping for OverDeliveryPolicyEnum. Resolve with the `t` pipe:
 * `{{ OVER_DELIVERY_POLICY_LABEL_KEYS[value] | t }}`
 */
export const OVER_DELIVERY_POLICY_LABEL_KEYS: Record<
  OverDeliveryPolicyEnum,
  string
> = {
  [OverDeliveryPolicyEnum.PERMISSIVE]:
    "MATERIAL.LOGISTIC_CONTROL.OVER_DELIVERY_POLICY.OPTIONS.PERMISSIVE",
  [OverDeliveryPolicyEnum.FREE]:
    "MATERIAL.LOGISTIC_CONTROL.OVER_DELIVERY_POLICY.OPTIONS.FREE",
  [OverDeliveryPolicyEnum.RESTRICTIVE]:
    "MATERIAL.LOGISTIC_CONTROL.OVER_DELIVERY_POLICY.OPTIONS.RESTRICTIVE",
};

/**
 * Options array for the "¿Se puede entregar más de lo que indica la entrega?" select.
 * `labelKey` is meant to be resolved with the `t` pipe in the template.
 */
export const OVER_DELIVERY_POLICY_OPTIONS: {
  value: OverDeliveryPolicyEnum;
  labelKey: string;
}[] = [
  {
    value: OverDeliveryPolicyEnum.PERMISSIVE,
    labelKey: OVER_DELIVERY_POLICY_LABEL_KEYS[OverDeliveryPolicyEnum.PERMISSIVE],
  },
  {
    value: OverDeliveryPolicyEnum.FREE,
    labelKey: OVER_DELIVERY_POLICY_LABEL_KEYS[OverDeliveryPolicyEnum.FREE],
  },
  {
    value: OverDeliveryPolicyEnum.RESTRICTIVE,
    labelKey: OVER_DELIVERY_POLICY_LABEL_KEYS[OverDeliveryPolicyEnum.RESTRICTIVE],
  },
];
